import React from "react";
import "components/General/Form/Form.css";

const CustomGenderRadio = (props) => {
  return (
    <div className="form-group gender">
      <table>
        <tbody>
          <tr>
            <td style={{ width: "25%", textAlign: "left" }}>
              Gender:{props.required ? "*" : ""}
            </td>
            <td style={{ width: "25%", textAlign: "left" }}>
              <input
                className="radio"
                id="boy"
                name="gender"
                type="radio"
                value="Male"
                checked={props.gender === "Male"}
                onChange={props.handleChange}
              />
              &nbsp;&nbsp;Male
            </td>
            <td style={{ width: "25%", textAlign: "left" }}>
              <input
                className="radio"
                id="girl"
                name="gender"
                type="radio"
                value="Female"
                checked={props.gender === "Female"}
                onChange={props.handleChange}
              />
              &nbsp;&nbsp;Female
            </td>
            <td style={{ width: "25%", textAlign: "left" }}>
              <input
                className="radio"
                id="nonbinary"
                name="gender"
                type="radio"
                value="Nonbinary"
                checked={props.gender === "Nonbinary"}
                onChange={props.handleChange}
              />
              &nbsp;&nbsp;Nonbinary
            </td>
          </tr>
        </tbody>
      </table>
      <div
        className="invalid-feedback"
        style={{ display: "block", marginLeft: "25%" }}
      >
        {props.error}
      </div>
    </div>
  );
};

export default CustomGenderRadio;
